import { render, staticRenderFns } from "./Zjxxrk.vue?vue&type=template&id=83558e96"
import script from "./Zjxxrk.vue?vue&type=script&lang=js"
export * from "./Zjxxrk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports